import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useUpdateCustomSurveyMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data?: Api.ICustomSurvey) => void;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ survey }: { survey: Api.ICustomSurvey }) => {
			return userSession.webServiceHelper.callAsync<Api.ICustomSurvey>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/custom/${survey.id}`,
				}),
				'PUT',
				survey
			);
		},
		onError,
		onSuccess,
	});
};
